"use client";

import Link from "next/link";
import { useEffect } from "react";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
    if (process.env.NODE_ENV === "development") {
        throw error; // forces Turbopack overlay
    }

  useEffect(() => {
    // Optional: send error to logging service
    console.error(error);
  }, [error]);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.code}>500</h1>

        {/* English Title */}
        <h2 style={styles.title}>Something Went Wrong</h2>

        {/* Chinese Title */}
        <h3 style={styles.subtitle}>系統發生錯誤</h3>

        {/* English Description */}
        <p style={styles.description}>
          An unexpected error has occurred. Please try again later or return to the homepage.
        </p>

        {/* Chinese Description */}
        <p style={styles.descriptionCn}>
          系統發生未預期錯誤，請稍後再試或返回首頁。
        </p>

        <div style={styles.buttonGroup}>
          <button
            onClick={() => reset()}
            style={styles.retryButton}
          >
            Retry / 重新嘗試
          </button>

          <Link href="/" passHref>
            <button style={styles.button}>
              Go Back Home / 返回首頁
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f0f2f5",
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    padding: "20px",
  },

  card: {
    backgroundColor: "#fff",
    padding: "40px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    maxWidth: "500px",
    width: "90%",
  },

  code: {
    fontSize: "100px",
    margin: "0",
    color: "#d32f2f",
    fontWeight: "700",
    lineHeight: "1",
  },

  title: {
    fontSize: "24px",
    color: "#333",
    marginBottom: "8px",
    marginTop: "20px",
    fontWeight: "600",
  },

  subtitle: {
    fontSize: "20px",
    color: "#555",
    fontWeight: "400",
    marginTop: "0",
    marginBottom: "24px",
  },

  description: {
    fontSize: "16px",
    color: "#666",
    lineHeight: "1.5",
    margin: "0 0 10px 0",
  },

  descriptionCn: {
    fontSize: "15px",
    color: "#888",
    lineHeight: "1.5",
    marginTop: "0",
    marginBottom: "30px",
  },

  buttonGroup: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
    flexWrap: "wrap",
  },

  button: {
    padding: "12px 24px",
    fontSize: "16px",
    color: "#fff",
    backgroundColor: "#0070f3",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "background-color 0.2s",
  },

  retryButton: {
    padding: "12px 24px",
    fontSize: "16px",
    color: "#fff",
    backgroundColor: "#d32f2f",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "background-color 0.2s",
  },
};